import SignifiLogs from "../../components/Logs/SignifiLogs";

const signifiLogRoutes = [
    {
        path: '', name: 'SignifiLogs', component: SignifiLogs,
    },
];

export default signifiLogRoutes;
